import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["nextLimit"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import SkeletonBase from '../../_core/common/components/loading/SkeletonBase';
import { USAGE_LIMIT_COUNTER } from '../../_core/common/constants/PurchaseMotionLocations';
import { PRICING_PAGE_REDIRECT } from '../../_core/purchaseMotions/PurchaseMotionTypes';
import UIPurchaseMotionButton from '../../button/UIPurchaseMotionButton';
import { jsx as _jsx } from "react/jsx-runtime";
const TooltipPurchaseMotionButton = _ref => {
  let {
      upgradeData,
      usageLimitBannerData: {
        nextLimit
      }
    } = _ref,
    usageLimitBannerData = _objectWithoutPropertiesLoose(_ref.usageLimitBannerData, _excluded);
  if (upgradeData === undefined) {
    return /*#__PURE__*/_jsx(SkeletonBase, {
      width: "50%",
      height: "16px"
    });
  }
  if (upgradeData === null) {
    return null; // Render nothing in case of error
  }
  const BYPASS_NEXT_LIMIT_CHECK_UPGRADE_KEYS = ['pro-email-sends-counter'];
  const nextLimitBypassed = !nextLimit && upgradeData.upgradeKey && BYPASS_NEXT_LIMIT_CHECK_UPGRADE_KEYS.includes(upgradeData.upgradeKey);
  const i18nKey = (!!nextLimit || nextLimitBypassed) && isValidI18nKey(`usageLimitCounter.${upgradeData.upgradeKey}.cta`) ? `usageLimitCounter.${upgradeData.upgradeKey}.cta` : 'usageLimitCounter.defaultCopy.cta';
  return /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
    passthroughProps: {
      pricingPageRedirect: {
        iconProps: null
      }
    },
    goToUpgradePage: true,
    level: 1,
    location: USAGE_LIMIT_COUNTER,
    purchaseMotions: [PRICING_PAGE_REDIRECT],
    truncate: false,
    upgradeData: upgradeData,
    usageLimitBannerData: usageLimitBannerData,
    use: "link",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      options: {
        nextLimit
      },
      message: i18nKey
    })
  });
};
export default TooltipPurchaseMotionButton;